import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { rem } from 'design-system/values';
import { isGestureNavigation } from 'utils/packages/navigationMode';
const BOTTOM_OFFSET = rem(16);
const isLtSdk29 = Platform.OS === 'android' && Platform.Version < 29;
export const useBottomOffset = () => {
    const { bottom } = useSafeAreaInsets();
    return isLtSdk29 && !isGestureNavigation
        ? bottom + BOTTOM_OFFSET
        : bottom || BOTTOM_OFFSET;
};
